export type WithoutLeadingSlash<Str extends string> =
  Str extends `/${infer Str2}` ? Str2 : Str;

export default function withoutLeadingSlash<const Str extends string>(
  str: Str,
): WithoutLeadingSlash<Str> {
  // @ts-expect-error - generic return type
  return str.startsWith('/') ? str.slice(1) : str;
}
